import React from "react";
import PropTypes from "prop-types";

const shapes = {
  circle: "rounded-[50%]",
  round: "rounded-[10px]",
};
const variants = {
  fill: {
    color_style_02_primary_blue_blue500: "bg-color_style-02_primary_blue-blue500 text-color_style-01_neutrals-grey50",
    blue_A200_19: "bg-blue-a200_19 text-color_style-02_primary_blue-blue500",
    blue_100_01: "bg-blue-100_01",
    blue_A200: "bg-blue-a200",
    light_blue_A700_33: "bg-light_blue-a700_33 text-muted",
    amber_800_26: "bg-amber-800_26 text-amber-800_01",
  },
  gradient: {
    indigo_800_color_style_02_primary_blue_blue500: "bg-gradient",
    color_style_linear_gradient_gray_900_05: "bg-gradient1",
  },
  outline: {
    color_style_02_primary_blue_blue500:
      "border-color_style-02_primary_blue-blue500 border-2 border-solid shadow-xs text-color_style-02_primary_blue-blue500",
  },
};
const sizes = {
  lg: "h-[48px] px-3.5",
  xs: "h-[32px] px-4 text-[13px]",
  "3xl": "h-[58px] px-[26px] text-[20px]",
  "6xl": "h-[72px] px-[34px] text-[28px]",
  "2xl": "h-[54px] px-6 text-[16px]",
  md: "h-[40px] px-[34px] text-[14px]",
  "4xl": "h-[60px] px-[34px] text-[24px]",
  xl: "h-[50px] px-[26px] text-[20px]",
  "5xl": "h-[60px] px-4",
  sm: "h-[32px] px-[22px] text-[19px]",
};

const Button = ({
  children,
  className = "",
  leftIcon,
  rightIcon,
  shape,
  variant = "fill",
  size = "sm",
  color = "color_style_02_primary_blue_blue500",
  ...restProps
}) => {
  return (
    <button
      className={`${className} flex flex-row items-center justify-center text-center cursor-pointer whitespace-nowrap ${shape && shapes[shape]} ${size && sizes[size]} ${variant && variants[variant]?.[color]}`}
      {...restProps}
    >
      {!!leftIcon && leftIcon}
      {children}
      {!!rightIcon && rightIcon}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  shape: PropTypes.oneOf(["circle", "round"]),
  size: PropTypes.oneOf(["lg", "xs", "3xl", "6xl", "2xl", "md", "4xl", "xl", "5xl", "sm"]),
  variant: PropTypes.oneOf(["fill", "gradient", "outline"]),
  color: PropTypes.oneOf([
    "color_style_02_primary_blue_blue500",
    "blue_A200_19",
    "blue_100_01",
    "blue_A200",
    "light_blue_A700_33",
    "amber_800_26",
    "indigo_800_color_style_02_primary_blue_blue500",
    "color_style_linear_gradient_gray_900_05",
  ]),
};

export { Button };
